import './index.scss'
import Loader from '../../../assets/images/spinner.svg'
import classNames from 'classnames'
import {useSelector} from 'react-redux'

const FullscreenLoader = () => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    return (
        <div className={classNames('fullscreen-loader', {
            'dark': isDarkMode
        })}>
            <img width="auto" height="auto" src={Loader} alt="Pinghome"/>
        </div>
    )
}

export default FullscreenLoader
